$.fn.ProductItem = function(category) {
  let item = this;

  // Detect if this is a bulk product (no .reg-price, just .cell-reg)
  let hasRegPrice = item.find('.cell-reg .reg-price').length > 0;
  item.isBulkProduct = !hasRegPrice && item.find('.cell-reg').length > 0;

  // Get price
  let priceText = '';
  if (hasRegPrice) {
    priceText = item.find('.cell-reg .reg-price').text();
  } else {
    priceText = item.find('.cell-reg').text().replace(/\s*\$\s*/, '');
  }
  item.price = parseFloat(priceText);

  // Parse weight multiplier ONLY for bulk products
  item.weightMultiplier = 1;
  if (item.isBulkProduct) {
    // For bulk products, the first td.text-center is the "Poids" column
    let weightCell = item.find('td.text-center').eq(0).text().trim();
    if (weightCell) {
      // Check for "X kg" format (ex: "4,5 kg", "1,5 kg")
      let kgMatch = weightCell.match(/([0-9]+[,.]?[0-9]*)\s*kg/);
      if (kgMatch) {
        item.weightMultiplier = parseFloat(kgMatch[1].replace(',', '.'));
      }
      // Check for "X unités (± Y kg)" format (ex: "6 unités (± 0,6 kg)")
      let unitKgMatch = weightCell.match(/unités\s*\(±\s*([0-9]+[,.]?[0-9]*)\s*kg\)/);
      if (unitKgMatch) {
        item.weightMultiplier = parseFloat(unitKgMatch[1].replace(',', '.'));
      }
      // If it's just "XL" (litres), keep multiplier at 1
    }
  }

  item.cell = {
    field: item.find('.form-control'),
    total: item.find('.cell-total'),
    cost: item.find('.cell-cost'),
    tps: item.find('.cell-tps'),
    tvq: item.find('.cell-tvq'),
  };
  item.taxes = item.cell.field.data("taxes");
  item.total = 0;
  item.tps = 0;
  item.tvq = 0;

  item.changed = function() {
    item.cell.field.val(item.cell.field.val().replace(",", "."));
    let value = parseFloat(item.cell.field.val());
    if (!value || isNaN(value)) {
      value = 0;
    }
    if (item.cell.field.data('round') == 1) {
      value = Math.floor(value);
      item.cell.field.val(value);
    }
    if (!value || value <= 0 || isNaN(value) || value == undefined) {
      item.total = 0;
      item.cell.field.val('');
      item.cell.total.text('0.00').parent().removeClass('text-bold');
    } else {
      // Apply weight multiplier for bulk products
      item.total = item.price * value * item.weightMultiplier;
      if (item.taxes == "taxable" || item.taxes == "tps") {
        item.tps = Math.round(item.total * 0.05 * 100) / 100;
      }
      if (item.taxes == "taxable" || item.taxes == "tvq") {
        item.tvq = Math.round(item.total * 0.09975 * 100) / 100;
      }
      item.cell.total.text(item.total.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).replace(',', '.')).parent().addClass('text-bold');
      item.cell.cost.val(item.total);
      item.cell.tps.val(item.tps);
      item.cell.tvq.val(item.tvq);
    }
    category.update();
  };

  item.getTotal = function() {
    return item.total;
  };

  item.getTPS = function() {
    return item.tps;
  };

  item.getTVQ = function() {
    return item.tvq;
  };

  return function() {
    item.cell.field.on('change', item.changed);
    return item;
  }();
}

$.fn.ProductsCategory = function(form) {
  let category = this;
  category.products = [];
  category.cell = {
    subtotal: category.find('.cell-subtotal'),
  };
  category.total = 0;
  category.tps = 0;
  category.tvq = 0;

  category.update = function() {
    let subtotal = 0, tps = 0, tvq = 0;
    category.products.forEach(function(product) {
      subtotal += product.getTotal();
      tps += product.getTPS();
      tvq += product.getTVQ();
    });
    category.total = subtotal;
    category.tps = tps;
    category.tvq = tvq;
    category.cell.subtotal.text(subtotal.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).replace(',', '.'));
    form.update();
  };

  category.getTotal = function() {
    return category.total;
  };

  category.getTPS = function() {
    return category.tps;
  };

  category.getTVQ = function() {
    return category.tvq;
  };

  return function() {
    category.find('tr.product').each(function() {
      let product = $(this).ProductItem(category);
      category.products.push(product);
    });
    return category;
  }();
};

$.fn.ProductsForm = function() {
  let self = this;
  self.categories = [];
  self.cell = {
    subtotal: self.find('.order-subtotal'),
    tps: self.find('.order-tps'),
    tvq: self.find('.order-tvq'),
    total: self.find('.order-total'),
    minimum: self.find('.cell-minimum'),
  };
  self.subtotal = 0;
  self.tps = 0;
  self.tvq = 0;
  self.total = 0;
  self.btn_submit = self.find('button[type="submit"]')
  self.minimum = self.find('input[name="minimum"]')
  self.inputs = self.find(':input:not(:disabled)')

  self.update = function() {
    let subtotal = 0, tps = 0, tvq = 0;
    self.categories.forEach(function(category) {
      subtotal += category.getTotal();
      tps += category.getTPS();
      tvq += category.getTVQ();
    });
    self.subtotal = parseFloat(parseFloat(subtotal).toFixed(2));
    self.tps = parseFloat(parseFloat(tps).toFixed(2));
    self.tvq = parseFloat(parseFloat(tvq).toFixed(2));
    self.total = self.subtotal + self.tps + self.tvq;
    self.cell.subtotal.text(self.subtotal.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).replace(',', '.'));
    self.cell.tps.text(self.tps.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).replace(',', '.'));
    self.cell.tvq.text(self.tvq.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).replace(',', '.'));
    self.cell.total.text(self.total.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).replace(',', '.'));
    let minimum = 100 - self.subtotal
    if (minimum > 0) {
      self.find('.minimum-order').show()
      self.btn_submit.addClass('disabled').prop('disabled', true)
      self.cell.minimum.text(mielsdanicet_commande_l10n.dollar_before + minimum.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).replace(',', '.') + mielsdanicet_commande_l10n.dollar_after)
      self.minimum.val(minimum)
    } else {
      self.find('.minimum-order').hide()
      self.btn_submit.removeClass('disabled').prop('disabled', false)
      self.cell.minimum.text(mielsdanicet_commande_l10n.dollar_before + minimum.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).replace(',', '.') + mielsdanicet_commande_l10n.dollar_after)
      self.minimum.val(minimum)
    }
  };

  self.nextInput = function(currentInput) {
    let nextInput = self.inputs.get(self.inputs.index(currentInput) + 1);
    if (nextInput) {
      nextInput.focus();
    }
  };

  self.getTotal = function() {
    return self.total;
  };

  return function() {
    // Include both regular products (calculated-table) and bulk products (without calculated-table)
    self.find('.category-table').each(function() {
      let category = $(this).ProductsCategory(self);
      self.categories.push(category);
    });

    self.find('.btn-action-reset').on('click', function() {
      if (confirm('Êtes-vous certain de vouloir réinitialiser la commande? Toutes les données seront perdues.')) {
        self.get(0).reset();
        self.find(':input').change();
        return false;
      }
      return false;
    });

    $(':input').on('keydown', function(event) {
      if (event.which == 13) {
        event.preventDefault();
        self.nextInput($(this));
      }
    })

    self.on('submit', function() {
      if (parseFloat(self.minimum.val()) > 0) {
        let content = $('.minimum-order').html().split(/<br\s*\/?>/i).map(line =>
          $('<div>').html(line).text().trim()
        ).join('\n');
        alert(content)
        return false
      }
    })

    return self;
  }();
}
